import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OwnerModel } from 'src/app/model/ownerModel.model';
import { ParcelModel } from 'src/app/model/parcelModel.model';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { AddressModel } from '../model/addressModel.model';
import { HttpErrorHandler } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class SessionCapModelService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService, private errorHandler: HttpErrorHandler) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/CapModel/';
  }

  saveAddressesToCapModel(addresses: Array<AddressModel>, module: string): Observable<string>{
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(addresses);
    return this.http.post(this.apiRef
      .getApiUrl(`${this.apiServer}SaveAddressesToCapModel`,[{Key:'module', Value:module}]), body, { headers })
      .pipe(map(resp => resp.toString()))
      .pipe(catchError(this.errorHandler.handleError));
  }

  getAddressesFromCapModel(module: string): Observable<Array<AddressModel>> {
    return this.http.get(this.apiRef
      .getApiUrl(`${this.apiServer}GetAddressesFromCapModel`,[{Key:'module', Value:module}])).pipe(map(resp => {
        resp = JSON.parse(resp.toString());
        if(resp && resp!=='null'){
          return resp as Array<AddressModel>;
        } else {
          return new Array<AddressModel>();
        }
    }))
    .pipe(catchError(this.errorHandler.handleError));
  }

  saveParcelsToCapModel(addresses: Array<ParcelModel>, module: string): Observable<string>{
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(addresses);
    return this.http.post(this.apiRef.getApiUrl(`${this.apiServer}SaveParcelsToCapModel`,[{Key:'module', Value:module}]), body, { headers })
    .pipe(map(resp => resp.toString()))
    .pipe(catchError(this.errorHandler.handleError));
  }

  getParcelsFromCapModel(module: string): Observable<Array<ParcelModel>> {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}GetParcelsFromCapModel`,[{Key:'module', Value:module}])).pipe(map(resp => {
      resp = JSON.parse(resp.toString());
      if(resp && resp!=='null'){
        return resp as Array<ParcelModel>;
      } else {
        return new Array<ParcelModel>();
      }
    }))
    .pipe(catchError(this.errorHandler.handleError));

  }

  saveOwnersToCapModel(addresses: Array<OwnerModel>, module: string): Observable<string>{
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(addresses);
    return this.http.post(this.apiRef.getApiUrl(`${this.apiServer}SaveOwnersToCapModel`,[{Key:'module', Value:module}]), body, { headers })
    .pipe(map(resp => resp.toString()))
    .pipe(catchError(this.errorHandler.handleError));
  }

  getOwnersFromCapModel(module: string): Observable<Array<OwnerModel>> {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}GetOwnersFromCapModel`,[{Key:'module', Value:module}])).pipe(map(resp => {
      resp = JSON.parse(resp.toString());
      if(resp && resp!=='null'){
        return resp as Array<OwnerModel>;
      } else {
        return new Array<OwnerModel>();
      }
    }))
    .pipe(catchError(this.errorHandler.handleError));

  }

}
